import { useState, type FormEvent } from "react";
import { useNavigate } from "react-router-dom";
import { AppShell } from "../components/AppShell";
import { normalizeStoreCode } from "../domain/config";

export function HomePage() {
  const [storeCode, setStoreCode] = useState("");
  const navigate = useNavigate();
  const submit = (event: FormEvent) => {
    event.preventDefault();
    navigate(`/store/${encodeURIComponent(normalizeStoreCode(storeCode))}`);
  };
  return (
    <AppShell title="Boil-outs, clearly tracked." subtitle="Open a store dashboard to review fryer status and record operational work.">
      <section className="hero-grid">
        <div className="hero-panel">
          <p className="eyebrow">Store access</p>
          <h2>Open your dashboard</h2>
          <form className="inline-form" onSubmit={submit}>
            <label>Store code<input value={storeCode} onChange={(event) => setStoreCode(event.target.value)} placeholder="CFA00000" /></label>
            <button className="button primary" type="submit">Continue</button>
          </form>
        </div>
        <div className="metric-panel">
          <span>One operational view</span>
          <strong>Operational · Needed · Overdue</strong>
          <p>Realtime Firestore data, auditable history, and configurable leadership notifications.</p>
        </div>
      </section>
    </AppShell>
  );
}
